import { render, staticRenderFns } from "./ItemActions.vue?vue&type=template&id=120a32a2&scoped=true&"
import script from "./ItemActions.vue?vue&type=script&lang=js&"
export * from "./ItemActions.vue?vue&type=script&lang=js&"
import style0 from "./ItemActions.vue?vue&type=style&index=0&id=120a32a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a32a2",
  null
  
)

export default component.exports